import { render, staticRenderFns } from "./shang-pin-zu-zhuang.vue?vue&type=template&id=7a114c82&scoped=true"
import script from "./shang-pin-zu-zhuang.vue?vue&type=script&lang=js"
export * from "./shang-pin-zu-zhuang.vue?vue&type=script&lang=js"
import style0 from "./shang-pin-zu-zhuang.vue?vue&type=style&index=0&id=7a114c82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a114c82",
  null
  
)

export default component.exports